import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LoadingState } from '~shared/models/status-state';
import { DeviceStatusState, statusFeatureKey } from './status.reducer';
import { restErrorEnum } from '~shared/error-helper';

export const selectStatusState = createFeatureSelector<DeviceStatusState>(statusFeatureKey);

export const selectStatus = createSelector(selectStatusState, (state) => state.status);
export const selectDeviceStatus = createSelector(selectStatusState, (state) => state.data);
export const selectLoadTime = createSelector(selectStatusState, (state) => state.loadTime);
export const selectStatusError = createSelector(selectStatusState, (state) =>
    state.errorMsg === restErrorEnum.notFound ? 'Device not found' : state.errorMsg
);
export const selectImpersonation = createSelector(selectStatusState, (state) => state.impersonation);

export const selectStatusIsLoading = createSelector(selectStatus, (status) => status === LoadingState.loading);
export const selectStatusIsRefreshing = createSelector(selectStatus, (status) => status === LoadingState.refreshing);
export const selectAttachmentsBusy = createSelector(selectStatusState, (state) => state.attachmentsBusy);
export const selectQrScannerIsOpen = createSelector(selectStatusState, (state) => state.qrScanner);
